'use client'

import { useUnitContext } from '@/hooks/useUnitContext'
import { ToggleButton } from '@desoutter/uikit'
import { useState } from 'react'

type ToggleUnitProps = {
	onChange?: (value: string) => void
}

export default function ToggleUnit({ onChange }: ToggleUnitProps) {
	const { unit, dispatch } = useUnitContext()
	const [state, setState] = useState<string>(unit)

	const handleOnChange = (value: string) => {
		setState(value)
		dispatch({ unit: value })
		onChange?.(value)
	}

	const units = [
		{
			label: 'Metric',
			value: 'Metric',
		},
		{
			label: 'Imperial',
			value: 'Imperial',
		},
	]
	return (
		<ToggleButton options={units} value={state} onChange={handleOnChange} />
	)
}
